import {
  ErrorHandler,
  Injector,
  Injectable
} from '@angular/core';
import { MessageService } from 'primeng/api';


@Injectable()
export class ApplicationInsightsErrorHandler implements ErrorHandler {
  constructor(private injector: Injector, private messageService: MessageService) {}
  handleError(error: any): void {
    console.group('🚨 Error Details');
   // this.injector.get <ApplicationInsightsService> (ApplicationInsightsService).logException(error);
    if (error.error && error.error.statusCode === 404 && error.error.message.includes('This iFacts ID has one or more materials that are not yet available in VIDA') ) {
      this.messageService.add({severity:'error', summary:'Material(s) not Found', detail:error.error.message});
    }

    console.error(error);
    // console.error('Error message:', error.message);
    // console.error('Stack trace:', error.stack);
    console.groupEnd();

  }
}
